import { render } from "./footer.vue?vue&type=template&id=31b788e3"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=31b788e3&lang=scss&rel=stylesheet%2Fscss"
script.render = render

export default script